import React from 'react';
import { WordpressPost } from '@benzinga/content-manager';
import styles from './PortfolioHeader.module.css';
import { faLinkedinIn } from '@fortawesome/free-brands-svg-icons/faLinkedinIn';
import { faFacebookF } from '@fortawesome/free-brands-svg-icons/faFacebookF';
import { faXTwitter } from '@fortawesome/free-brands-svg-icons/faXTwitter';
import { Icon } from '@benzinga/core-ui';
import Image from 'next/image';
import { sanitizeHTML } from '@benzinga/frontend-utils';

export interface PortfolioHeaderProps {
  post: WordpressPost;
}

export const PortfolioHeader: React.FC<PortfolioHeaderProps> = ({ post }) => {
  const [shareURL, setShareURL] = React.useState<string>('');

  React.useEffect(() => {
    if (post?.canonical_link) {
      setShareURL(encodeURIComponent(post?.canonical_link));
    }
  }, [post]);

  const socialLinks = [
    {
      icon: faLinkedinIn,
      link: `https://www.linkedin.com/shareArticle?mini=true&url=${shareURL}`,
      title: 'LinkedIn',
    },
    {
      icon: faXTwitter,
      link: `https://twitter.com/intent/tweet?text=${shareURL}`,
      title: 'Twitter',
    },
    {
      icon: faFacebookF,
      link: `https://www.facebook.com/sharer/sharer.php?u=${shareURL}`,
      title: 'Facebook',
    },
  ];

  return (
    <div className={styles.wrapper}>
      <div className="header-container mx-auto layout-container flex flex-col md:flex-row items-center">
        <div className="portfolio-header-wrapper">
          <div className={styles.edgePromo}>
            Powered By{' '}
            <a
              href="https://www.benzinga.com/premium/ideas/benzinga-edge-checkout/?utm_source=portfolio-title"
              rel="noreferrer"
              target="_blank"
            >
              <Image alt="Benzinga Edge" height={12} src="/next-assets/images/bz-edge-logo.svg" width={135} />
            </a>
          </div>
          <a
            className={styles.portfolioTitle}
            href="https://www.benzinga.com/premium/ideas/benzinga-edge-checkout/?utm_source=portfolio-title"
            rel="noreferrer"
            target="_blank"
          >
            <h2>{post.title}</h2>
          </a>

          <div className="flex justify-between flex-col gap-2">
            <div>
              <p dangerouslySetInnerHTML={{ __html: sanitizeHTML(post.intro ?? '') }} />
            </div>
            <div className={styles.shareIcons}>
              <ul className="flex flex-row">
                {socialLinks?.map((item, i) => {
                  return (
                    <li className={styles.socialShare} key={i}>
                      <a href={item.link} rel="noreferrer" target="_blank" title={item.title}>
                        <Icon className="text-[15px]" icon={item.icon} />
                      </a>
                    </li>
                  );
                })}
                <li>
                  <a
                    href="https://news.google.com/publications/CAAqJggKIiBDQklTRWdnTWFnNEtER0psYm5wcGJtZGhMbU52YlNnQVAB?hl=en-US&gl=US&ceid=US%3Aen"
                    rel="noreferrer"
                    target="_blank"
                    title={'Follow on Google News'}
                  >
                    <Image
                      alt=""
                      className="h-auto max-w-full"
                      height={40}
                      src="/next-assets/images/google-news.png"
                      width={130}
                    />
                  </a>
                </li>
                <li>
                  <a
                    href="https://apple.news/TkIgt4-hMRsyTLpDXncCSFg?subscribe=1"
                    rel="noreferrer"
                    target="_blank"
                    title={'Follow on Apple News'}
                  >
                    <Image
                      alt=""
                      className="h-auto max-w-full"
                      height={38}
                      src="/next-assets/images/apple-news.png"
                      width={78}
                    />
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
